module.exports = __webpack_public_path__ + "static/media/template-3.7566d6df.png";